import educationImg from '../assets/education1.webp'; // Use appropriate image path
import Footer from './Footer';

export default function OHSEducation() {
  return (
    <div className='md:mt-[10px] mt-[100px]'>
      <img
        src={educationImg}
        alt="Education Image"
        className="w-full h-[200px] md:h-[500px] object-cover"
      />

      <div className="bg-white p-12 text-center bg-inspiration-geometry">
        <h2 className="text-4xl font-maiandra mb-4">Workplace Safety Training & Certification Programs</h2>
        <p className="text-gray-700 lg:ml-[33%] md:ml-[15%] font-myriad max-w-lg">
          OHS Education is focused on building a robust educational platform for OHS professionals and organizations. This division runs a training and educational center that offers certification programs, safety workshops, and continuous learning opportunities to empower companies and individuals in maintaining workplace safety standards.
        </p>

        <br /><br /><br /><br />

        <h2 className="text-4xl font-maiandra mb-4">Key Services</h2>
        <br />
        <ul className="list-none pl-0 md:pl-64 mb-6 text-left lg:text-center text-gray-900 space-y-1">
        <li className="flex items-start pl-2">
        <span className="mr-2 text-black text-xl">•</span>OHS certification programs and workshops</li>
        <li className="flex items-start pl-2">
        <span className="mr-2 text-black text-xl">•</span>Continuous professional development courses</li>
        <li className="flex items-start pl-2">
        <span className="mr-2 text-black text-xl">•</span>Industry-specific safety training</li>
        <li className="flex items-start pl-2">
        <span className="mr-2 text-black text-xl">•</span>Safety leadership and management development programs</li>
        </ul>

        <br /><br /><br /><br />

        <div className="p-1 md:p-8">
          <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="bg-gray-900 p-6 text-white rounded-lg shadow-lg mb-8">
              <h2 className="text-2xl font-maiandra mb-4">Key Strengths</h2>
              <ul className="list-none pl-0 mb-6 text-left text-gray-100 space-y-1">
              <li className="flex items-start pl-2">
              <span className="mr-2 text-white text-xl">•</span>Expert-Led Programs: Courses designed and taught by experienced OHS professionals with hands-on industry knowledge.</li>
              <li className="flex items-start pl-2">
              <span className="mr-2 text-white text-xl">•</span>Comprehensive Curriculum: A wide range of programs tailored to diverse industries, ensuring that professionals are equipped to handle real-world safety challenges.</li>
              <li className="flex items-start pl-2">
              <span className="mr-2 text-white text-xl">•</span>Accredited Certifications: Industry-recognized certifications that enhance career prospects and ensure compliance with national and international safety standards.</li>
              <li className="flex items-start pl-2">
              <span className="mr-2 text-white text-xl">•</span>Flexible Learning Solutions: A combination of in-person workshops, online courses, and blended learning options, allowing participants to learn at their own pace.</li>
              <li className="flex items-start pl-2">
              <span className="mr-2 text-white text-xl">•</span>Continuous Professional Development: A strong emphasis on lifelong learning and skills enhancement through regular updates, refresher courses, and advanced training modules.</li>
              </ul>
            </div>

            <div className="bg-gray-900 p-6 rounded-lg shadow-lg mb-8">
              <h2 className="text-2xl font-maiandra text-white mb-4">Comprehensive Solutions</h2>
              <ul className="list-none pl-0 mb-6 text-left text-gray-100 space-y-1">
              <li className="flex items-start pl-2">
              <span className="mr-2 text-white text-xl">•</span>Offering training programs aligned with industry standards.</li>
              <li className="flex items-start pl-2">
              <span className="mr-2 text-white text-xl">•</span>Expert guidance on maintaining compliance with safety regulations.</li>
              <li className="flex items-start pl-2">
              <span className="mr-2 text-white text-xl">•</span>Personalized learning paths to fit the needs of individuals and companies alike.</li>
              </ul>
            </div>
          </div>
          <br /><br />
        </div>
      </div>

      <Footer />
    </div>
  );
}
